
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function LoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  
const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) navigate("/dashboard");
  }, [navigate]);

  useEffect(() => {
    const savedUsername = localStorage.getItem("rememberUsername");
    const savedPassword = localStorage.getItem("rememberPassword");
    if (savedUsername && savedPassword) {
      setUsername(savedUsername);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(
        "https://perambalur-swm-api.circularctech.com/api/Auth/login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username, password }),
        }
      );

      if (!response.ok) throw new Error("Invalid username or password");

      const data = await response.json();
      const actualUsername = data.username || data.fullName || username;
      const roles = data.roleId;
      const actualBlockname = data.blockName;
      const actualPanchayatname = data.panchayatName;

      localStorage.setItem(
        "userData",
        JSON.stringify({ ...data, username: actualUsername,blockname: actualBlockname, panchayatname: actualPanchayatname })
      );

      if (data.token) localStorage.setItem("authToken", data.token);
      localStorage.setItem("blockName", actualBlockname);
      localStorage.setItem("panchayatName", actualPanchayatname);
      localStorage.setItem("roleId", roles);

      if (rememberMe) {
        localStorage.setItem("rememberUsername", actualUsername);
        localStorage.setItem("rememberPassword", password);
         localStorage.setItem("blockName", actualBlockname);
      localStorage.setItem("panchayatName", actualPanchayatname);
      localStorage.setItem("roleId", roles);
      } else {
        localStorage.removeItem("rememberUsername");
        localStorage.removeItem("rememberPassword");
      }

      if ([1, 2, 3, 4].includes(roles)) {
        navigate("/dashboard");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = () => navigate("/forgot-password");

  return (
    <div
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center cursor-default select-none"
      style={{
        backgroundImage: "url('/images/login-bg.png')",
      }}
    >
      {/* 🔹 Overlay to make background subtle */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* 🔸 Highlighted Login Card */}
      <div className="relative z-10 bg-white/90 p-8 rounded-2xl shadow-2xl border border-yellow-300 hover:shadow-yellow-400/40 transition-all duration-300 w-full max-w-sm">
        <div className="text-center mb-6">
          <img
            src="/images/cclogo.png"
            alt="Compost Logo"
            className="w-20 mx-auto mb-3 drop-shadow-md"
          />
          <h2 className="text-3xl font-extrabold text-yellow-700 drop-shadow-sm">
            Perambalur DRDA
          </h2>
          <p className="text-gray-600 text-sm mt-2">
            Smart Waste Tracking for Compost Shed
          </p>
        </div>

        {error && (
          <div className="bg-red-100 text-red-700 p-2 mb-4 rounded-lg text-center shadow-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-yellow-800 font-medium mb-1">
              Username
            </label>
            <input
              type="text"
              required
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full border border-yellow-300 bg-yellow-50 px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500"
              placeholder="Enter username"
            />
          </div>

        <div className="relative">
  <label className="block text-yellow-800 font-medium mb-1">
    Password
  </label>

  <input
    type={showPassword ? "text" : "password"}
    required
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    className="w-full border border-yellow-300 bg-yellow-50 px-3 py-2 pr-10 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500"
    placeholder="Enter password"
  />

  <button
    type="button"
    onClick={() => setShowPassword(!showPassword)}
    className="absolute right-3 top-[38px] text-gray-500 hover:text-yellow-600"
  >
    {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
  </button>
</div>



          <div className="flex items-center justify-between">
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="form-checkbox text-yellow-600 focus:ring-yellow-500"
              />
              <span className="text-gray-800 text-sm">Remember Me</span>
            </label>
            <button
              type="button"
              onClick={handleForgotPassword}
              className="text-yellow-700 hover:text-yellow-800 text-sm font-medium"
            >
              Forgot Password?
            </button>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-yellow-500 to-yellow-600 text-white font-semibold py-2 rounded-lg hover:from-yellow-600 hover:to-yellow-700 transition-all shadow-lg hover:shadow-yellow-500/40 disabled:opacity-50"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

              <div className="mt-8 text-center text-xs text-gray-600 space-y-1">
  <p>
    By continuing, you agree to our{" "}
    <Link
      to="/privacy-policy"
      className="text-yellow-700 font-medium hover:underline"
    >
      Privacy Policy
    </Link>
  </p>
  <p>Powered by CircularCarbon Technologies</p>
</div>


      </div>
    </div>
  );
}
